import RestClient from './rest-client'

export default class ServicePostalCode extends RestClient {
  static get url () {
    return this.apiUrl + '/service_postal_codes'
  }

  static get paramKey () {
    return 'service_postal_code'
  }

  static async uploadFile (formData) {
    const { data } = await this._post(this.url + '/upload', formData)
    return data
  }

  static async importFile (formData) {
    const { data } = await this._post(this.url + '/import', formData)
    return data
  }

  static async deleteAll (serviceId) {
    const { data } = await this._delete(this.apiUrl + `/services/${serviceId}` + '/service_postal_codes/destroy_all')
    return data
  }

  static async deleteZonePostalCodes (zoneId) {
    const { data } = await this._delete(this.url + `/${zoneId}` + '/delete_zone_postal_codes')
    return data
  }
}
